import React from "react";

type BrandLogoProps = {
  className?: string;
  markClassName?: string;
  textClassName?: string;
  showTagline?: boolean;
  showSubtitle?: boolean;
  stacked?: boolean;
};

type BrandMarkProps = {
  className?: string;
};

export function BrandMark({ className }: BrandMarkProps) {
  return (
    <svg
      viewBox="0 0 96 96"
      aria-hidden="true"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0"
        y="0"
        width="96"
        height="96"
        rx="22"
        className="fill-[var(--color-content-primary)]"
      />
      <rect
        x="22"
        y="22"
        width="44"
        height="44"
        rx="9"
        strokeWidth="4.5"
        fill="none"
        className="stroke-[var(--color-action-primary)]"
      />
      <path
        d="M44 22V66"
        strokeWidth="3.5"
        strokeLinecap="round"
        className="stroke-[var(--color-action-primary)]"
      />
      <path
        d="M22 44H66"
        strokeWidth="3.5"
        strokeLinecap="round"
        className="stroke-[var(--color-action-primary)]"
      />
      <path
        d="M19 59L32 47L44 52L55 40L64 32"
        strokeWidth="5.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="stroke-[var(--color-status-info)]"
      />
      <path
        d="M58 31L67 29L64 38"
        strokeWidth="4.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="stroke-[var(--color-status-success)]"
      />
      <circle cx="32" cy="47" r="4" className="fill-[var(--color-status-info)]" />
      <circle cx="55" cy="40" r="4" className="fill-[var(--color-status-info)]" />
    </svg>
  );
}

export function BrandLogo({
  className,
  markClassName,
  textClassName,
  showTagline = false,
  showSubtitle = true,
  stacked = false,
}: BrandLogoProps) {
  return (
    <div className={className}>
      <div className={`flex items-center ${stacked ? "flex-col gap-4 text-center" : "gap-4"}`}>
        <BrandMark className={markClassName} />
        <div className={textClassName}>
          <div
            className={
              stacked
                ? "font-[family-name:var(--font-family-display)] text-3xl font-medium tracking-[-0.04em] text-[var(--color-content-primary)] sm:text-4xl"
                : "font-[family-name:var(--font-family-display)] text-xl font-medium tracking-[-0.04em] text-[var(--color-content-primary)] sm:text-2xl"
            }
          >
            activityviz
          </div>
          {showTagline ? (
            <div
              className={
                stacked
                  ? "mt-1 text-xs font-medium uppercase tracking-[0.24em] text-[var(--color-action-primary)] sm:text-sm"
                  : "mt-1 text-[0.7rem] font-medium uppercase tracking-[0.24em] text-[var(--color-action-primary)] sm:text-xs"
              }
            >
              maps, charts, and motion
            </div>
          ) : showSubtitle ? (
            <div
              className={
                stacked
                  ? "mt-1 text-sm text-[var(--color-content-secondary)] sm:text-base"
                  : "mt-1 text-xs text-[var(--color-content-secondary)] sm:text-sm"
              }
            >
              Visualize how you move
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}
